import ContentPage from "./ContentPage";
import Accordion from "../ui/Accordion";
import { HELP } from "../data/legal";

/**
 * Topics disclose what they cover. They deliberately do not answer anything —
 * the source had no answers anywhere, and invented support instructions on a
 * live help page are worse than none.
 *
 * The disclosure behaviour is the shared Accordion. This page used to carry
 * its own copy of it, built on a framer `height: auto` animation, which meant
 * every open and close was a measured layout pass and none of it worked before
 * hydration.
 */
export default function Help() {
  const topics = HELP.topics.map((topic) => ({
    q: topic.heading,
    items: topic.items,
  }));

  return (
    <ContentPage title={HELP.title} lead={HELP.lead}>
      <Accordion
        items={topics}
        getKey={(topic) => topic.q}
        render={(topic) => (
          <ul>
            {topic.items.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        )}
      />

      <section className="content-page__section">
        <h2 className="content-page__heading">Contact support</h2>
        <p className="t-body content-page__paragraph">
          Write to{" "}
          <a href={`mailto:${HELP.contact.email}`}>{HELP.contact.email}</a> and
          someone will get back to you — {HELP.contact.note}.
        </p>
      </section>
    </ContentPage>
  );
}
